/*
 * @message:在这里对请求参数封装，包括公共参数，系统参数,签名
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-06 15:16:35
 * @FilePath: \mrc-ess-fronted\src\api\api.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 15:25:46
 */

import ajaxRequest from "@/api/request";
import { getOsInfo, getBrowser } from "@/util/system";
const crypto = require("crypto");

const apiVersion = "v1";
const hmac_key = "299cb5bb4c9040a29c58304c25001d72";
let sign = "";
function getParams(table = undefined, data, notUser = false) {
  let lang = localStorage.getItem("mrc-ess-base-application-default-lang");
  var curdata = Object.assign(
    {},
    {
      "system-language-code": lang ? lang : "en",
      "system-client-version": "1",
      "system-client-type": "Web",
      "system-version": getBrowser(),
      "device-type": getOsInfo().name,
      "client-type": "ESS-WEB",
      "client-version-name": "V2.0",
      "client-version-code": "V2.0",
      "current-utc-time": new Date().getTime(),
      "time-zone-offset": ~new Date().getTimezoneOffset() + 1,
      // "sign": "123",
      "theme-mode": "light",
    },
    table ? { "~table~": table } : {},
    data ? data : {},
    notUser
      ? {}
      : {
          token: data.token
            ? data.token
            : localStorage.getItem("mrc-ess-base-application-user-token"),
        }
  );
  return curdata;
}
// **************高级参照***************/
export function findPrompt(
  data,
  global = false,
  type = null,
  notAlert = false,
  notUser = false
) {
  if (!data) data = {};
  data["client_uuid"] = "9527";
  return ajaxRequest(
    {
      formData: JSON.stringify(getParams("mrbase_sys_prompt", data, notUser)),
    },
    "/prompt/business/findPrompt/" + apiVersion,
    "POST",
    crypto
      .createHmac("sha1", hmac_key)
      .update(JSON.stringify(getParams("mrbase_sys_prompt", data, notUser)))
      .digest("hex"),
    global,
    type,
    notAlert
  );
}
export function Request(args) {
  let data = {};
  if (!args.data) args.data = {};
  // if (args.data['files']) {
  //   let formData = new FormData();
  //   formData.append('')
  // }
  if (args.data["files"]) {
    data["files"] = args.data["files"];
  } //文件上傳特殊
  // 排除登录接口传token
  data["formData"] = JSON.stringify(
    getParams(args.table, args.data, args.notUser)
  );
  // args["type"] == "upload" ||
  //       args["type"] == "lang" ||
  //       args["type"] == "base"
  //         ? ""
  //         :
  return ajaxRequest(
    data,
    args.url + (args.version ? args.version : apiVersion),
    args.method ? "POST" : args.method,
    crypto
      .createHmac("sha1", hmac_key)
      .update(JSON.stringify(getParams(args.table, args.data, args.notUser)))
      .digest("hex"),
    args["global"] !== undefined ? args["global"] : true,
    args["type"],
    args["notAlert"] !== undefined ? args["notAlert"] : false,
    args["export_title"] !== undefined ? args["export_title"] : null
  );
}
export let api = null; //全局请求
